import { render, staticRenderFns } from "./review-list-card.vue?vue&type=template&id=4831ef54&scoped=true&"
import script from "./review-list-card.vue?vue&type=script&lang=js&"
export * from "./review-list-card.vue?vue&type=script&lang=js&"
import style0 from "./review-list-card.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./review-list-card.vue?vue&type=style&index=1&id=4831ef54&lang=scss&scoped=true&"
import style2 from "./review-list-card.vue?vue&type=style&index=2&id=4831ef54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4831ef54",
  null
  
)

export default component.exports
import {QRating,QScrollArea,QInfiniteScroll,QInnerLoading,QSpinnerIos,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QRating,QScrollArea,QInfiniteScroll,QInnerLoading,QSpinnerIos,QIcon})
